import { Form, Success } from './components';

const WithdrawAccountFlow = {
  Form,
  Success,
};

export { WithdrawAccountFlow };
